<template>
  <div>
    <!-- 头部 S-->
    <Head></Head>
    <!-- 头部 E -->
    <div class="main w">
      <h6>
        キーワード：{{ $route.query.result }}
        <span>検索結果に問題あり？</span>
        <em>
          全
          <b>{{ amount }}</b
          >件の関係商品
        </em>
      </h6>
      <!-- main 头部-->
      <div class="main-top">
        <dl>
          <dt>仕入れ先：</dt>
          <dd>すべて</dd>
          <dd @click="getList" class="cur">
            RAKUMART
            <img src="../../assets/img/rakumart.png" alt />
          </dd>
          <dd @click="typeDite(1688)">
            Alibaba
            <img src="../../assets/img/1688.png" alt />
          </dd>
          <dd @click="typeDite('taobao')">
            TAOBAO
            <img src="../../assets/img/taobao.png" alt />
          </dd>
          <dd @click="typeDite('tmall')">
            TMALL
            <img src="../../assets/img/tmall.png" alt />
          </dd>
        </dl>
      </div>
      <!-- 筛选 -->
      <div class="main-map">
        <span>総合</span>
        <ul>
          <li>
            取引数
            <i class="el-icon-caret-top" id="i-top"></i>
            <i class="el-icon-caret-bottom" id="i-bottom"></i>
          </li>
          <li>
            価格
            <i class="el-icon-caret-top" id="i-top"></i>
            <i class="el-icon-caret-bottom" id="i-bottom"></i>
            <input
              type="text"
              v-model="list.priceMin"
              oninput="value=value.replace(/[^\d]/g, '')"
              @keydown.enter="getList"
            />
            -
            <input
              type="text"
              v-model="list.priceMax"
              style="margin: 0"
              @keydown.enter="getList"
              oninput="value=value.replace(/[^\d]/g, '')"
            />
          </li>
          <li>
            最小ロット
            <input
              type="text"
              v-model="least"
              style="margin-right: 10px"
              oninput="value=value.replace(/[^\d]/g, '')"
            />
            <el-button size="mini">搜索</el-button>
          </li>
          <li class="place">
            所在地
            <i class="el-icon-caret-bottom"></i>
            {{ list.province }}
            <div class="localtion"></div>
          </li>
        </ul>
      </div>
      <!-- 商品 -->
      <div class="commodity" v-if="amount !== 0">
        <!--  自营 -->
        <ul>
          <li
            v-for="item in lists"
            :key="item.id"
            @click="getSearchGoodsList(item.product_item_id)"
          >
            <div class="mian-item-img">
              <img :src="item.image" alt />
            </div>
            <span>￥{{ item.price_pifa }}</span>
            <span style="color: #f3c622; margin-left: 30px"
              >{{ Math.ceil(item.price_pifa * exchangeRate) }}(円)</span
            >
            <p :title="item.title_japanese">{{ item.title_japanese }}</p>
          </li>
        </ul>
        <!-- 分页 -->
        <div class="fenye">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="list.page"
            :page-size="list.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="amount"
          ></el-pagination>
        </div>
      </div>
      <!-- 搜索错误 -->
      <div v-else>
        <error></error>
      </div>
    </div>
    <!-- 尾部 -->
    <Foot></Foot>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import Head from "../../components/head/Head";
import Foot from "../../components/foot/Foot";
import error from "./error";
import { getList, getList1688 } from "../../api/API/list";
export default {
  metaInfo: {
    title: "カテゴリー",
    meta: [
      {
        name: "discription",
        content: "我们不做产品，只做产品的搬运工",
      },
      { name: "keywords", content: "内衣，内裤，衣服，裤子" },
    ],
  },
  data() {
    return {
      imgFlag: false,
      least: "", // 最少手数
      list: {
        // 发送请求参数
        keywords: "",
        cid: "",
        page: 1,
        pageSize: 40,
        priceMin: "",
        priceMax: "",
      },
      lists: [], // 返回数据
      amount: 1, // 总数量
      total: 1, // 当前页
      currentPage4: 1,
      // 搜索错误
      radio: 0,
      suggest: "",
    };
  },
  components: {
    Head,
    Foot,
    error,
  },
  created() {
    if (this.$route.query.img != undefined) {
      this.imgList();
    } else {
      this.getList();
    }
  },
  computed: {
    ...mapState(["result", "exchangeRate", "imgData"]),
  },
  methods: {
    // 请求数据
    getList() {
      this.list.keywords = this.$route.query.result;
      this.list.cid = this.$route.query.cid;
      getList(this.list).then((res) => {
        if (res.code != 0) return;
        this.lists = res.data.data;
        this.amount = res.data.total;
      });
    },
    // 图片搜索数据
    imgList() {
      this.lists = this.imgData.slice(0, 40);
      this.amount = this.imgData.length;
      this.imgFlag = true;
    },
    // 筛选 类型 1688
    typeDite(type) {
      var result = "";
      if (this.$route.query.result != undefined) {
        result = this.$route.query.result;
      } else {
        return this.$router.push("/list1688");
      }
      this.$router.push({
        path: "/list1688?result=" + result + "&type=" + type,
      });
    },
    handleSizeChange(val) {},
    handleCurrentChange(val) {
      this.list.page = val;
      if (!this.imgFlag) {
        this.getList();
      } else {
        if (val == 1) {
          this.lists = this.imgData.data.slice(0, 40);
        } else if (val == 2) {
          this.lists = this.imgData.data.slice(40, 80);
        } else {
          this.lists = this.imgData.data.slice(80, 100);
        }
      }
      window.scrollTo(0, 211);
    },
    //商品跳转
    getSearchGoodsList(id) {
      let routeUrl = this.$router.resolve({
        path: "/details?id=" + id,
      });
      window.open(routeUrl.href, "_blank");
    },
    // 重置页码
    resetPageNum() {
      this.list.page = 1;
    },
  },
};
</script>
<style lang='scss' scoped>
.main {
  h6 {
    margin: 45px 0 20px;
    font-size: 16px;
    span {
      margin-left: 33px;
      font-weight: 700;
    }
    em {
      float: right;
    }
    b {
      color: #f3c622;
    }
  }
  .main-top {
    height: 90px;
    border: 1px solid #ccc;
    margin-bottom: 20px;
    dl {
      line-height: 90px;
      font-size: 16px;
      font-weight: 700;

      dt {
        margin: 0 130px 0 110px;
        float: left;
      }
      dd {
        float: left;
        margin-left: 100px;
        cursor: pointer;
        &:hover {
          color: #f3c622;
          text-decoration: underline;
        }
        img {
          vertical-align: middle;
          margin-left: 10px;
        }
      }
      .cur {
        color: #f3c622;
        text-decoration: underline;
      }
    }
  }
  .main-map {
    height: 50px;
    background: #f2f2f2;
    margin-bottom: 30px;
    span {
      display: block;
      float: left;
      height: 50px;
      color: #333;
      text-align: center;
      width: 118px;
      line-height: 50px;
      background: #f3c622;
      font-size: 16px;
    }
    ul {
      float: left;
      li {
        position: relative;
        float: left;
        margin-left: 118px;
        font-size: 16px;
        line-height: 50px;
        #i-top {
          position: absolute;
          top: 12px;
        }
        #i-bottom {
          position: absolute;
          top: 23px;
        }
        input {
          margin-left: 20px;
          width: 100px;
          height: 20px;
        }
      }
      .place {
        &:hover .localtion {
          display: block;
        }
        position: relative;
        .localtion {
          position: absolute;
          left: -100px;
          height: 20px;
          width: 300px;
          height: 500px;
          background: #ccc;
          display: none;
        }
      }
    }
  }
  .commodity {
    overflow: hidden;
    ul {
      overflow: hidden;
      li {
        float: left;
        width: 276px;
        height: 380px;
        border: 2px solid transparent;
        margin-bottom: 20px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        cursor: pointer;

        &:hover {
          border-color: #f3c622;
        }

        &:hover img {
          transform: scale(1.2);
        }

        .mian-item-img {
          width: 260px;
          height: 280px;
          margin: 10px 10px 12px;
          overflow: hidden;

          img {
            width: 260px;
            height: 280px;
            transition: all 0.3s;
          }
        }

        p {
          margin: 8px 0 0 10px;
          font-size: 14px;
          width: 260px;
          line-height: 20px;
          height: 40px;
          overflow: hidden;
        }

        span {
          padding-left: 10px;
          font-size: 20px;
          font: 700;
          color: red;
          //   text-shadow: 0 2px 4px rgba(245, 4, 4, 0.12),
          //     0 0 6px rgba(252, 7, 7, 0.04);
          font-weight: 700;
        }
      }
    }
    .fenye {
      width: 500px;
      margin: 30px auto 50px;
      text-align: center;
    }
  }
}
</style>